import React from 'react'
import { PageProps } from 'gatsby'

export type RegionContext = {
  children?: React.ReactNode
  regions: PageProps<Queries.PageTemplateQuery>['data']['directus']['regions']
}

export type RegionProvider = {
  children?: React.ReactNode
  regions: PageProps<Queries.PageTemplateQuery>['data']['directus']['regions']
}

export const RegionContext = React.createContext<RegionContext | null>(null)

export const RegionsProvider = ({ children, regions }: RegionProvider) => (
  <RegionContext.Provider
    value={{
      regions
    }}
  >
    {children}
  </RegionContext.Provider>
)
